export enum AvailableFeatureFlags {
  disableRecaptcha = 'g-recaptcha-override',
}
